import { Component, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { OrderService } from '../../../orders/services/order.service';
import { ReportType } from '../../../../models/report.model';

@Component({
  selector: 'app-products',
  standalone: true, imports: [RouterLink, CurrencyPipe],
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss'
})
export class ProductsComponent implements OnInit {
  currency = 'PLN'
  primaryPrice = 9
  extendedPrice = 49

  constructor(private _orderService:OrderService) {
  }

  ngOnInit() {
     this._getPrices()
  }

  private _getPrices() {
    this._orderService.getProductsPriceByName(ReportType.PRIMARY).subscribe((data) => {
      this.primaryPrice = data.data.amount/100;
    });
    this._orderService.getProductsPriceByName(ReportType.EXTENDED).subscribe((data) => {
      this.extendedPrice = data.data.amount/100;
    });

  }

}
